import * as React from 'react';

import {ChannelPicker} from 'shells/channels/channel-picker';
import {FormWrapperWithButtons} from 'shells/form/form-wrapper-with-buttons';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ModalLightbox} from 'shells/modal/modal-lightbox';
import {TextField} from 'shells/textfield/textfield';

import type {ChannelType} from 'nutshell-graphql-types';

import type {SourceValues} from '../types';

import styles from './source-modal.module.css';

type Props = {
    onClose: () => void;
    onSubmit: (name: string, channel?: ChannelType | null | undefined, id?: string) => any;
    title: string;
    buttonText: string;
    isSaving: boolean;
    initialValues?: SourceValues;
};

export function SourceModalContent(props: Props) {
    const [nameValue, setNameValue] = React.useState<string | null | undefined>(
        props.initialValues ? props.initialValues.name : undefined
    );
    const [channelSelection, setChannelSelection] = React.useState<ChannelType | null | undefined>(
        props.initialValues ? props.initialValues.channel : undefined
    );

    return (
        <ModalLightbox onClose={props.onClose}>
            <div className={styles.container}>
                <FormWrapperWithButtons
                    title={props.title}
                    isSaving={props.isSaving}
                    onCancel={props.onClose}
                    onSaveClick={() => {
                        if (nameValue) {
                            props.onSubmit(
                                nameValue,
                                channelSelection,
                                props.initialValues ? props.initialValues.id : undefined
                            );
                        }
                    }}
                    buttonText={props.buttonText}
                    saveButtonDisabled={!nameValue}
                    resetOnSaveComplete={true}
                >
                    <StackLegacy spacing={12}>
                        <div className={styles['option-container']}>
                            <div>Name</div>
                            <TextField
                                id='name'
                                // @ts-expect-error
                                name='Name'
                                maxLength={255}
                                focusOnMount={true}
                                selectOnFocus={true}
                                required={true}
                                placeholder='Your source’s name'
                                value={nameValue || ''}
                                onChange={(name: string) => setNameValue(name)}
                            />
                        </div>
                        <div className={styles['option-container']}>
                            <div>Channel</div>
                            <div className='full-width'>
                                <ChannelPicker
                                    onSelectChannel={(channel: ChannelType) =>
                                        setChannelSelection(channel)
                                    }
                                    channelSelection={channelSelection}
                                    autoFocus={false}
                                    includeNoChannelOption={true}
                                />
                            </div>
                        </div>
                    </StackLegacy>
                </FormWrapperWithButtons>
            </div>
        </ModalLightbox>
    );
}
